import createCache from '@emotion/cache';

const defaultMantineEmotionCache = createCache({ key: "mantine", prepend: true });

export { defaultMantineEmotionCache };
//# sourceMappingURL=default-emotion-cache.js.map
